import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  button: {
    padding: theme.spacing(0.5),
  },
  input: {
    width: 80,
    '& input': {
      textAlign: 'center',
      padding: theme.spacing(1),
    },
  },
}));
